var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Facilities",
            "tabActive": "Meitex_China",
            "bg": "/images/sub/visual/sv-facilities.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first"
  }, [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v("Meitex_China")])]), _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit tit--symbol",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("니팅 및 제직 공장")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text grey-a--text text-right"
  }, [_vm._v("Meitex_China")])])], 1), _c('v-divider', {
    staticClass: "border-2 grey-2 mt-14 mb-24 mt-md-20 mb-md-40"
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "height": "100%",
      "src": "/images/sub/facilities/facilities-img.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto d-none d-md-block",
    attrs: {
      "height": "100%",
      "src": "/images/sub/facilities/facilities-img6.jpg"
    }
  }), _c('v-row', {
    staticClass: "d-md-none"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img2.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img3.jpg"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img2.jpg"
    }
  })], 1), _c('v-col', {
    staticClass: "d-none d-md-block",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img3.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img4.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img5.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img7.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img8.jpg"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('sub-section', {
    staticClass: "page-section--last"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit tit--symbol",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("R&D 룸_ 쇼룸")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text grey-a--text text-right"
  }, [_vm._v("Meitex_China")])])], 1), _c('v-divider', {
    staticClass: "border-2 grey-2 mt-14 mb-24 mt-md-20 mb-md-40"
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img9.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img10.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/facilities-img11.jpg"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }